<mat-dialog-content>
  <div id="export-dialog-wrapper">
    <div id="header">
      <div id="title">Export</div>
      <div id="type-selection">
        <p id="export-type-question">Which format would you like to export?</p>
        <nav id="tab-container">
          <a (click)="setExportTab(ExportType.pdf)" [class.active]="chosenExportType === ExportType.pdf" class="pdfTab"
             *ngIf="pdfPermitted">
            <img id="imgPdf" src="assets/pdf.svg" class="downloadImage" (click)="setExportTab(ExportType.pdf)"/> PDF</a>
          <a (click)="setExportTab(ExportType.excel)" [class.active]="chosenExportType === ExportType.excel"
             class="excelTab">
            <img id="imgExcel" src="assets/excel.svg" class="downloadImage" (click)="setExportTab(ExportType.excel)"/>
            Excel</a>
          <a (click)="setExportTab(ExportType.csv)" [class.active]="chosenExportType === ExportType.csv" class="csvTab">
            <img id="imgCsv" src="assets/csv.svg" (click)="setExportTab(ExportType.csv)" class="downloadImage"/> CSV</a>
        </nav>
      </div>
    </div>
    <div id="question-inclusions"
         *ngIf="chosenExportType === ExportType.excel || chosenExportType === ExportType.csv">What would you like to
      include?
    </div>
    <div id="body">
      <app-select-pdf-export *ngIf="chosenExportType === ExportType.pdf" [afterOptionsSelected]="afterPdfSelected">
      </app-select-pdf-export>
      <div id="csv-and-excel" *ngIf="chosenExportType === ExportType.excel || chosenExportType === ExportType.csv">
        <mat-selection-list id="metric-list">
        <span *ngFor="let option of displayedMultilevelExportOptions"
              [ngClass]="option.loaded ? 'option' : 'option-inactive'"
              (click)="whenOptionExpanded(option, $event)" [matTooltip]="greyMetricMessage" [matTooltipDisabled]="option.loaded
            || option.id === 0">
        <span [ngClass]="getCssClassBasedOnExpansion(option.depth)">
          <mat-checkbox [checked]="option.selected" (click)="whenOptionSelected(option, $event)"
                        class="option-box"></mat-checkbox>
          <span class="metric-text">{{option.text}}</span>
        </span>
        <i *ngIf="option.children.length >= 1 && !(option.id === 0)"
           [ngClass]="'fa fa-caret-'.concat(option.nodeExpansionState === NodeExpansionState.EXPANDED ? 'up' :
            option.nodeExpansionState === NodeExpansionState.COLLAPSED ? 'down' : '')"></i>
        </span>
        </mat-selection-list>
      </div>
    </div>
    <hr>
    <div id="export-buttons">
      <button class="cancel-button" mat-flat-button (click)="closeExportOptions()">Cancel</button>
      <button [ngClass]="exportPermitted ? 'export-button' : 'grey-export-button'" mat-raised-button (click)="export()">
        Export
      </button>
      <span id="wait-for-export" *ngIf="isExporting">please wait...</span>
    </div>
  </div>
</mat-dialog-content>
